import { isOnboardingFinished } from "../../../../../Utils/onboarding/isOnboardingFinished"

// Why the merchant cannot act on the Integrate step yet, or null when they can.
// "onboarding": the Getting started steps are unfinished (RCV-3-21) — the wizard is viewable
// but connect/disconnect and moving past Integrate are off. "demo": the account has not been
// activated yet, the same state in which Alerts disables its processor actions.
export const setupLockReason = (userInfo) => {
  if (!userInfo) return null
  if (!isOnboardingFinished(userInfo)) return "onboarding"
  if (userInfo.is_demo) return "demo"
  return null
}
